import { NgModule } from '@angular/core';
import { SamplesComponent } from './samples.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule,
  ],
})
export class SamplesModule {
}
